// extracted by mini-css-extract-plugin
export default {"page":"hGLRp","pluginPage":"bgnHX","loading":"ZUn7w","header":"GfMGa"};